import React, { useState } from 'react'
import { Row } from 'react-bootstrap';
import { authAxios } from '../../../API/apiRequest';
import { Button } from '../../../components/Button/Button';
import { FieldComponent } from '../AddJob/components/FieldComponent';
import { EmployerLayout } from "../Layout/EmployerLayout"

const ChangePassword: React.FC = ()=>{
    const [password, setPassword] = useState<string>('')
    const [newPassword, setNew] = useState<string>('')
    const [confirmNewPassword, setConfirm] = useState<string>('')
    const [error, setError] = useState<string>('')
    const [done, setDone] = useState<string>('')
    const [saving, setSaving] = useState<boolean>(false)

    const onSubmit = async()=>{
        try{
            if(password.trim() === '' || newPassword.trim() === '' || confirmNewPassword.trim() === '')
              return setError('من فضلك قم بكتابة كلمة المرور الحالية والجديدة')
            if(newPassword !== confirmNewPassword) return setError('كلمة المرور الجديدة غير متطابقة')
            setSaving(true)
            let result = await authAxios.post('employer/password', {old: password, password: newPassword})
            setSaving(false)
            if(result.status === 200){
               setPassword('')
               setNew('')
               setConfirm('')
               return setDone('تم تغيير كلمة المرور')
            }
             
        }catch(e: any){
            console.log(e)
            setSaving(false)
            setPassword('')
            setNew('')
            setConfirm('')
            if(e.response)
                return setError(e.response.data.errors[0])
            else
                return setError('حدث خطأ من فضلك حاول مرة اخري')
        }

    }

    return(
        <EmployerLayout>
        <Row>
          <FieldComponent 
              value={password} 
              onChangeValue={(v: string)=>{setPassword(v); setError('')}} 
              width={250} 
              title='كلمة المرور الحالية' 
              placeholder='كلمة المرور' 
              inputType='password'
            />
        </Row>
        <Row>
          <FieldComponent 
              value={newPassword} 
              onChangeValue={(v: string)=>{setNew(v); setError('')}} 
              width={250} 
              title='كلمة المرور الجديدة' 
              placeholder='كلمة المرور الجديدة' 
              inputType='password'
            />
        </Row>
        <Row>
          <FieldComponent 
              value={confirmNewPassword} 
              onChangeValue={(v: string)=>{setConfirm(v)}} 
              width={250} 
              title='تأكيد كلمة المرور الجديدة' 
              placeholder='كلمة المرور الجديدة' 
              inputType='password'
            />
        </Row>
        <Row style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <p style={{color: 'tomato', textAlign: 'center', fontSize: 16, marginTop: 15, marginBottom: 0}}>{error && error}</p>
          <p style={{color: 'rgb(10,230,10)', textAlign: 'center', fontSize: 16, marginTop: 15, marginBottom: 0}}>{done && done}</p>
          <Button
            loading={saving} 
            style={{marginBottom: 25, marginTop: 25}} 
            height={60} 
            onPress={onSubmit}
            color='#1D8C49'
            hoverColor='#0e6b33'
            >حفظ</Button>
        </Row>
        </EmployerLayout>
    )
}

export default ChangePassword